import { useMemo } from "react";
import { Table as TableCmp, ProgressBar, TextLikeLink } from "@components";
import { WORKSPACES_PATH } from "pages/router";
import type { GridRenderCellParams } from "@mui/x-data-grid";
import type { IProject, IProjectsLanguages } from "features/projects/types";
import type { IWorkspaceId } from "features/workspaces/types";
import { isLanguageHidden } from "features/languages/utils";

export const Project = ({ project, workspaceId }: { project: IProject; workspaceId: IWorkspaceId }) => {
  const visibleLanguages = project.projectsLanguages.filter(lang => !isLanguageHidden(lang.languageId));

  const columns = useMemo(
    () => [
      {
        field: "languageId",
        headerName: "Language",
        flex: 1,
        renderCell: (params: GridRenderCellParams) => (
          <>
            <TextLikeLink>{params?.row?.languageId}</TextLikeLink>
            <a
              className="row-as-link"
              href={`#/${WORKSPACES_PATH}/${workspaceId}/${project.id}/${params.row.id}`}
              aria-label={params.row.id}
            >
              &nbsp;
            </a>
          </>
        ),
      },
      {
        field: "completenessPercents",
        headerName: "Progress",
        flex: 1,
        renderCell: (params: GridRenderCellParams) => <ProgressBar percentage={params.formattedValue} />,
      },
      {
        flex: 1,
        field: "phrasesCount",
        headerName: "Approved / Total phrases",
        valueGetter: (rawValue: any, row: IProjectsLanguages) => {
          const { phrasesCount, approvedPhrasesCount } = row;
          return `${approvedPhrasesCount} / ${phrasesCount}`;
        },
      },
    ],
    [workspaceId, project.id],
  );

  return <TableCmp rows={visibleLanguages} columns={columns} isRowLink storageId={`projectLanguages${project.id}`} />;
};
